import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  VStack,
} from '@chakra-ui/react';
import { CPFInput } from '../../../ui/components/atoms/Input';
import { useForm } from 'react-hook-form';
import { useTheme } from '../../../ui/contexts/ThemeProvider';
import validateCPF from '../../../../sites/dashboard/src/utils/CPFValidator';
import { updateCPF } from '../../subscription/api';
import React from 'react';

export const ModalCPF = ({ isOpen, onClose, cnpj }: { isOpen: boolean; onClose: (cpf: string) => void; cnpj: string }) => {
  const theme = useTheme();

  const [isLoading, setIsLoading] = React.useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  async function doUpdateProfile(data: Record<string, string>) {
    setIsLoading(true);
    if (!validateCPF(data.cpf)) {
      setError('cpf', {
        type: 'manual',
        message: 'CPF inválido',
      });
      return;
    }
    try {
      await updateCPF({
        cnpj:  cnpj.replace(/\D/g, ''),
        document_for_cnpj: data.cpf.replace(/\D/g, ''),
      });
      onClose(data.cpf);
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  }

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>CNPJ encontrado!</ModalHeader>
        <ModalBody>
          <VStack>
            <Text>Para continuar precisamos vincular seu CPF a sua conta. Por favor, preencha o campo abaixo.</Text>
            <form onSubmit={handleSubmit(doUpdateProfile)} style={{ width: '100%' }}>
              <CPFInput {...register('cpf')} label="CPF" />
              {errors.cpf && typeof errors.cpf.message === 'string' && (
                <Text fontSize={12} color="red.500">
                  {errors.cpf.message}
                </Text>
              )}
            </form>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            isLoading={isLoading}
            onClick={handleSubmit(doUpdateProfile)}
            color="white"
            backgroundColor={theme.colors.primaryColor}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
